import { Component } from '@angular/core';
import { HxLabel } from '../../label/label';

/**
 * Table footer container component
 *
 * Used to display footer content like totals, counts, or summary information at the bottom of the table. The footer
 * spans all columns and does not participate in the table grid layout. Uses HxLabel for consistent text styling.
 *
 * @example
 *   ```html
 *   <hx-table>
 *     <hx-table-header>
 *       <hx-header-cell>Column 1</hx-header-cell>
 *     </hx-table-header>
 *
 *     <hx-table-row>
 *       <hx-table-cell>Data</hx-table-cell>
 *     </hx-table-row>
 *
 *     <hx-table-footer>
 *       <hx-label description="Total Count: 10"></hx-label>
 *     </hx-table-footer>
 *   </hx-table>
 *   ```;
 */
@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'hx-table-footer',
  standalone: true,
  imports: [HxLabel],
  template: '<ng-content />',
  host: {
    class: 'hx-table-footer',
  },
})
export class HxTableFooterDirective {}
